import FadeSlideInTransition from '../transition/FadeSlideInTransition';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ConsentPromptTransitionWrapper = ({
  children,
  consentPromptEnabled,
  isVisible,
  onExited
}) => {
  if (!consentPromptEnabled) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(FadeSlideInTransition, {
    in: Boolean(isVisible),
    duration: 400,
    direction: "bottom",
    addEndListener: () => {},
    onExited: onExited,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
ConsentPromptTransitionWrapper.displayName = 'ConsentPromptTransitionWrapper';
export default ConsentPromptTransitionWrapper;